import React, { useEffect, useState } from "react";
import RoleApi from "../../api/RoleApi";
import NewUserApi from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function AddDetails({ fetchUsers }) {

  const [roles, setRoles] = useState([]);
const [loadingRoles, setLoadingRoles] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const [formData, setFormData] = useState({
    roleId: "",
    username: "",
    name: "",
    email: "",
    phone: "",
    location: "",
    password: "",
    confirmPassword: "",
    photo: null,
  });

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFormData((prev) => ({ ...prev, photo: file }));
    setPhotoPreview(URL.createObjectURL(file));
  };

  /* -------------------- LOGIC: REGEX PATTERNS -------------------- */
  const patterns = {
    name: /^[a-zA-Z\s]{3,50}$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    phone: /^[6-9]\d{9}$/,
    username: /^[a-zA-Z0-9_]{3,20}$/,
  };

  const validateField = (name, value) => {
    if (
      !value &&
      [
        "roleId",
        "username",
        "name",
        "email",
        "phone",
        "location",
        "password",
        "confirmPassword",
      ].includes(name)
    ) {
      return `${name} is required`;
    }
    switch (name) {
      case "name":
        return !patterns.name.test(value) ? "Min 3 alphabets required" : "";
      case "email":
        return !patterns.email.test(value) ? "Invalid email address" : "";
      case "phone":
        return !patterns.phone.test(value) ? "Invalid 10-digit number" : "";
      case "username":
        return !patterns.username.test(value)
          ? "Invalid username (3-20 chars)"
          : "";
      case "password":
        return value.length < 6 ? "Min 6 characters required" : "";
      case "confirmPassword":
        return value !== formData.password ? "Passwords do not match" : "";
      default:
        return "";
    }
  };

  // Debounce Validation Effect
  useEffect(() => {
    const handler = setTimeout(() => {
      const newErrors = {};
      Object.keys(formData).forEach((key) => {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      });
      setErrors(newErrors);

      const requiredFields = [
        "roleId",
        "username",
        "name",
        "email",
        "phone",
        "location",
        "password",
        "confirmPassword",
      ];
      const allFilled = requiredFields.every((f) => formData[f]?.trim() !== "");
      setIsFormValid(allFilled && Object.keys(newErrors).length === 0);
    }, 500);
    return () => clearTimeout(handler);
  }, [formData]);

  /* -------------------- HANDLERS -------------------- */
  const handleKeyPress = (e) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
  };

  const handleNumberInput = (e, limit) => {
    if (e.target.value.length > limit)
      e.target.value = e.target.value.slice(0, limit);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  // useEffect(() => {
  //   RoleApi.list().then((res) => res.code === 200 && setRoleList(res.data));
  // }, []);

const fetchRoles = async () => {
  try {
    setLoadingRoles(true);

    const res = await RoleApi.list();

    console.log("ROLES API RESPONSE:", res);

    if (res?.code === 200) {
      const roleList = Array.isArray(res.data)
        ? res.data
        : [];

      const validRoles = roleList.filter(
        (item) =>
          item &&
          item._id &&
          item.role &&
          item.isDeleted !== true
      );

      console.log("ALL VALID ROLES:", validRoles);

      setRoles(validRoles);
    } else {
      console.error("Roles API failed:", res);
      setRoles([]);
    }
  } catch (error) {
    console.error("Failed to fetch roles:", error);
    setRoles([]);
  } finally {
    setLoadingRoles(false);
  }
};
  useEffect(() => {
  fetchRoles();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;
    try {
      setLoading(true);
      const form = new FormData();

      // normal fields append karo
      form.append("roleId", formData.roleId);
      form.append("username", formData.username);
      form.append("name", formData.name);
      form.append("email", formData.email);
      form.append("phone", formData.phone);
      form.append("location", formData.location);
      form.append("password", formData.password);
      form.append("confirmPassword", formData.confirmPassword);

      // 🔥 YEH IMPORTANT HAI
      if (formData.photo) {
        form.append("avatar", formData.photo); // must match backend
      }

      const res = await NewUserApi.add(form);
      if (res.code === 200) {
        showSuccess("User created successfully!");
        setFormData({
          roleId: "",
          username: "",
          name: "",
          email: "",
          phone: "",
          location: "",
          password: "",
          confirmPassword: "",
        });
        setTouched({});
        if (fetchUsers) fetchUsers();
        document.getElementById("closeOffcanvasBtn").click();
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getValidationClass = (name) => {
    if (!touched[name]) return "form-control";
    return errors[name] ? "form-control is-invalid" : "form-control is-valid";
  };

  return (
    <div>
      <style>{`
        input::-webkit-outer-spin-button, input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>

      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Add New User</h5>
        <button
          type="button"
          id="closeOffcanvasBtn"
          className="btn-close custom-btn-close border p-1 rounded-circle"
          data-bs-dismiss="offcanvas"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-12 mb-4">
  <label className="form-label fw-semibold">Profile Photo</label>

  <div className="d-flex align-items-center gap-3">

    <img
      src={
        photoPreview ||
        "https://ui-avatars.com/api/?name=User&background=eee"
      }
      alt="preview"
      className="rounded-circle"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "cover",
        border: "2px solid #e5e5e5"
      }}
    />

    <input
      type="file"
      accept="image/*"
      className="form-control"
      onChange={handlePhotoChange}
    />

  </div>
</div>
            {/* Role Select */}
            <div className="col-md-12 mb-3">
             <div className="form-group">
  <label>
    Role <span className="text-danger">*</span>
  </label>

<select
  name="roleId"
  value={formData.roleId}
  onChange={handleChange}
  className={`form-select ${
    touched.roleId
      ? errors.roleId
        ? "is-invalid"
        : "is-valid"
      : ""
  }`}
  disabled={loadingRoles}
>
  <option value="">
    {loadingRoles
      ? "Loading roles..."
      : roles.length === 0
        ? "No roles available"
        : "Select Role"}
  </option>

  {roles.map((role) => (
    <option
      key={role._id}
      value={role._id}
    >
      {role.role}
    </option>
  ))}
</select>

{touched.roleId && errors.roleId && (
  <div className="invalid-feedback">
    {errors.roleId}
  </div>
)}
</div>
            </div>

            {/* Username */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                User Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={getValidationClass("username")}
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              {touched.username && errors.username && (
                <div className="invalid-feedback">{errors.username}</div>
              )}
            </div>

            {/* Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={getValidationClass("name")}
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              {touched.name && errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            {/* Email */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className={getValidationClass("email")}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {touched.email && errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            {/* Phone */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Phone <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className={getValidationClass("phone")}
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                onInput={(e) => handleNumberInput(e, 10)}
              />
              {touched.phone && errors.phone && (
                <div className="invalid-feedback">{errors.phone}</div>
              )}
            </div>

            {/* Location */}
            <div className="col-md-12 mb-3">
              <label className="form-label">
                Location <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={getValidationClass("location")}
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
              {touched.location && errors.location && (
                <div className="invalid-feedback">{errors.location}</div>
              )}
            </div>

            {/* Password */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group input-group-flat">
                <input
                  type={showPassword ? "text" : "password"}
                  className={getValidationClass("password")}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={showPassword ? "ti ti-eye" : "ti ti-eye-off"} />
                </span>
                {touched.password && errors.password && (
                  <div className="invalid-feedback d-block">
                    {errors.password}
                  </div>
                )}
              </div>
            </div>

            {/* Confirm Password */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Confirm Password <span className="text-danger">*</span>
              </label>
              <div className="input-group input-group-flat">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className={getValidationClass("confirmPassword")}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i
                    className={
                      showConfirmPassword ? "ti ti-eye" : "ti ti-eye-off"
                    }
                  />
                </span>
                {touched.confirmPassword && errors.confirmPassword && (
                  <div className="invalid-feedback d-block">
                    {errors.confirmPassword}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-light me-2"
              data-bs-dismiss="offcanvas"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn btn-primary ${!isFormValid || loading ? "disabled" : ""}`}
              disabled={!isFormValid || loading}
            >
              {loading ? "Creating..." : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddDetails;
